import styled from "styled-components";

export const StyledSection = styled.section`
  width: 100%;
  height: calc(100vh - 108px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledLoading = styled.img`
  width: 200px;
`;